(() => {
  if (window.pawkivoKachingDefaultUpsells) return;
  const initialized = window.pawkivoKachingDefaultUpsells = new Set();
  const widgetSelector = 'kaching-bundles-block[deal-block-id]';

  const selectDefault = () => {
    for (const widget of document.querySelectorAll(widgetSelector)) {
      if (!widget.querySelector('.kaching-bundles__block--loaded')) continue;
      let upsells;
      try {
        upsells = JSON.parse(widget.getAttribute('deal-block') || '{}').checkboxUpsells?.upsells;
      } catch (error) {
        console.warn('Kaching default upsell configuration is invalid', error);
        continue;
      }
      if (!Array.isArray(upsells)) continue;

      // shortcut: 按 Kaching 当前组件顺序定位加购项，应用更改结构时需重新核对。
      const checkboxes = widget.querySelectorAll('.kaching-bundles__checkbox-upsells__upsell [role="checkbox"]');
      if (checkboxes.length !== upsells.length) continue;
      upsells.forEach((upsell, index) => {
        if (!upsell?.id) return;
        const key = `${widget.getAttribute('deal-block-id')}:${upsell.id}`;
        if (initialized.has(key)) return;
        const checkbox = checkboxes[index];
        const checked = checkbox.getAttribute('aria-checked');
        if (checked !== 'true' && checked !== 'false') return;
        if (checkbox.getAttribute('aria-disabled') === 'true') return;

        // 用逻辑 ID 记住首次处理，顾客取消后即使组件重绘也不再强制勾选。
        initialized.add(key);
        if (checked === 'false') checkbox.click();
      });
    }
  };

  const observer = new MutationObserver(records => {
    const changed = records.some(record => record.target.closest?.(widgetSelector)
      || [...record.addedNodes].some(node => node.nodeType === 1
        && (node.matches(widgetSelector) || node.querySelector(widgetSelector))));
    if (changed) selectDefault();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  selectDefault();
})();
